<template>
  <div v-if="show" class="gam-overlay" @click.self="close">
    <div class="gam-modal">
      <!-- Botón de Cerrar -->
      <button @click="close" class="gam-close-btn" title="Cerrar">&times;</button>

      <!-- Encabezado Principal -->
      <div class="gam-header">
        <img src="@/assets/promolider_logo_2.png" alt="Promolíder" class="gam-logo" />
        <h2 class="gam-title">Únete a Promolíder</h2>
        <p class="gam-subtitle">Elige cómo deseas registrarte para acceder a la plataforma y guardar tu progreso:</p>
      </div>

      <!-- Contenedor de Opciones (2 Columnas) -->
      <div class="gam-options-grid">
        <!-- ================= OPCIÓN 1: GRATIS ================= -->
        <div class="gam-card gam-card--free">
          <div class="gam-card__badge-wrap">
            <span class="gam-badge gam-badge--free">Cuenta Estándar</span>
          </div>

          <h3 class="gam-card__title">Cuenta Gratuita</h3>
          <p class="gam-card__desc">
            Crea tu cuenta gratuita en Promolíder para acceder a este curso por el precio regular y avanzar a tu propio ritmo.
          </p>

          <div class="gam-card__features">
            <div class="gam-feature-item">
              <svg class="gam-check-icon" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              <span>Acceso de por vida al contenido</span>
            </div>
            <div class="gam-feature-item">
              <svg class="gam-check-icon" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              <span>Certificado de finalización oficial</span>
            </div>
            <div class="gam-feature-item">
              <svg class="gam-check-icon" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              <span>Guarda tu avance y notas en la nube</span>
            </div>
          </div>

          <div class="gam-card__price">
            <span class="gam-price-tag">GRATIS</span>
            <span class="gam-price-sub">Sin cargos mensuales</span>
          </div>

          <button @click="openRegister('free')" class="gam-btn gam-btn--free">
            Continuar con Cuenta Gratis
          </button>
        </div>

        <!-- ================= OPCIÓN 2: MEMBRESÍA VIP ================= -->
        <div class="gam-card gam-card--vip">
          <div class="gam-card__badge-wrap">
            <span class="gam-badge gam-badge--vip">
              <svg class="tw-w-3.5 tw-h-3.5" viewBox="0 0 24 24" fill="#facc15">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
              </svg>
              Recomendado
            </span>
          </div>

          <h3 class="gam-card__title">Únete a Promolíder VIP</h3>
          <p class="gam-card__desc">
            Obtén <strong>descuentos exclusivos</strong> en este y todos los cursos, herramientas pro y genera comisiones en tu red.
          </p>

          <div class="gam-card__features">
            <div class="gam-feature-item">
              <svg class="gam-check-icon" style="color: #F59E0B;" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              <span>Descuentos especiales en todos los cursos</span>
            </div>
            <div class="gam-feature-item">
              <svg class="gam-check-icon" style="color: #F59E0B;" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              <span>Acceso a la plataforma de Network Marketing</span>
            </div>
            <div class="gam-feature-item">
              <svg class="gam-check-icon" style="color: #F59E0B;" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
              </svg>
              <span>Gana increíbles comisiones por referir</span>
            </div>
          </div>

          <!-- Selector de Planes VIP -->
          <div v-if="memberships.length > 0" class="gam-plan-selector">
            <label class="gam-plan-label">Selecciona tu plan:</label>
            <select v-model="selectedMembershipIndex" @change="updateFeaturedMembership" class="gam-select">
              <option v-for="(m, i) in memberships" :key="i" :value="i">
                {{ m.account || m.name }} - ${{ m.price }} USD/AÑO
              </option>
            </select>
          </div>

          <!-- Vista previa de la Tarjeta VIP 3D -->
          <div class="gam-vip-preview">
            <div class="gam-vip-scale">
              <VipMembershipCard :membership="featuredMembership" :user="{ name: 'Nuevo', last_name: 'Miembro' }" />
            </div>
          </div>

          <button @click="openRegister('vip')" class="gam-btn gam-btn--vip">
            Registrarme como VIP
          </button>
        </div>
      </div>

      <!-- Pie del Modal: Iniciar Sesión para existentes -->
      <div class="gam-footer">
        <span class="gam-footer__text">¿Ya tienes una cuenta en Promolíder?</span>
        <router-link :to="{ name: 'Login' }" class="gam-login-link">
          Iniciar Sesión
        </router-link>
      </div>
    </div>

    <!-- Modal de Registro Rápido integrado -->
    <QuickRegisterModal
      :show="showQuickRegister"
      :visible="showQuickRegister"
      :type="registerType"
      :ref-id="sponsorRefId"
      :plan-id="selectedPlanId"
      @close="showQuickRegister = false"
      @success="handleRegisterSuccess"
    />
  </div>
</template>

<script>
import VipMembershipCard from "@/components/VipMembershipCard.vue";
import QuickRegisterModal from "@/components/QuickRegisterModal.vue";

export default {
  name: "GuestAuthModal",
  components: {
    VipMembershipCard,
    QuickRegisterModal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showQuickRegister: false,
      registerType: "free",
      sponsorRefId: "",
      selectedPlanId: "",
      memberships: [],
      selectedMembershipIndex: 0,
      featuredMembership: null
    };
  },
  watch: {
    show(newVal) {
      if (newVal && this.memberships.length === 0) {
        this.fetchMemberships();
      }
    }
  },
  mounted() {
    if (this.show) {
      this.fetchMemberships();
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    async fetchMemberships() {
      try {
        const response = await this.axios.get("/public/membership-plans");
        let plans = [];
        if (response.data && Array.isArray(response.data.data)) {
          plans = response.data.data;
        } else if (response.data && Array.isArray(response.data)) {
          plans = response.data;
        }

        if (plans.length > 0) {
          this.memberships = plans;
          // Por defecto seleccionar el plan de mayor valor o University
          let defIndex = plans.findIndex(p => (p.account || '').toLowerCase().includes('university'));
          if (defIndex === -1) defIndex = plans.length > 2 ? 2 : 0;
          this.selectedMembershipIndex = defIndex;
          this.featuredMembership = this.memberships[defIndex];
        } else {
          throw new Error("No memberships returned");
        }
      } catch (err) {
        console.warn("Using fallback memberships:", err);
        this.memberships = [
          { id: 2, account: "School", price: "100.00", iva: 18, disc_purchases_course: 10, pay_in_binary: 20, fast_cash_bonus: 18, productor_bonus: 15, course_selling_bonus: 20 },
          { id: 3, account: "Academy", price: "305.00", iva: 18, disc_purchases_course: 15, pay_in_binary: 30, fast_cash_bonus: 18, productor_bonus: 20, course_selling_bonus: 20 },
          { id: 4, account: "University", price: "805.00", iva: 18, disc_purchases_course: 20, pay_in_binary: 40, fast_cash_bonus: 20, productor_bonus: 30, course_selling_bonus: 25 },
          { id: 5, account: "Socio Fundador", price: "1313.56", iva: 18, disc_purchases_course: 25, pay_in_binary: 50, fast_cash_bonus: 20, productor_bonus: 30, course_selling_bonus: 25 }
        ];
        this.selectedMembershipIndex = 2; // University
        this.featuredMembership = this.memberships[2];
      }
    },
    updateFeaturedMembership() {
      this.featuredMembership = this.memberships[this.selectedMembershipIndex];
    },
    getSponsorId() {
      return this.$route?.query?.ref ||
        localStorage.getItem("ref_distributor_id") ||
        localStorage.getItem("sponsor_ref_id") ||
        "1";
    },
    openRegister(type) {
      this.sponsorRefId = this.getSponsorId();
      this.registerType = type;

      if (type === "vip" && this.featuredMembership) {
        this.selectedPlanId = this.featuredMembership.id || this.featuredMembership.account;
      } else {
        this.selectedPlanId = "";
      }

      this.showQuickRegister = true;
    },
    handleRegisterSuccess() {
      this.showQuickRegister = false;
      this.$emit("close");
      // Recargar para que Vuex y la página actual reconozcan la sesión activa
      window.location.reload();
    }
  }
};
</script>

<style scoped>
.gam-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  overflow-y: auto;
}

.gam-modal {
  position: relative;
  width: 100%;
  max-width: 920px;
  background-color: #0f172a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  color: #f8fafc;
  animation: gam-modal-in 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes gam-modal-in {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.gam-close-btn {
  position: absolute;
  top: 18px;
  right: 18px;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  color: #94a3b8;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  font-size: 1.4rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  z-index: 10;
}
.gam-close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.gam-header {
  padding: 28px 32px 16px;
  text-align: center;
}

.gam-logo {
  height: 34px;
  width: auto;
  margin: 0 auto 12px;
  display: block;
}

.gam-title {
  font-size: 1.75rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 6px;
  letter-spacing: -0.5px;
}

.gam-subtitle {
  font-size: 0.92rem;
  color: #94a3b8;
  max-width: 580px;
  margin: 0 auto;
}

/* ================= GRID 2 COLUMNAS ================= */
.gam-options-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 16px 32px 24px;
}

@media (max-width: 768px) {
  .gam-options-grid {
    grid-template-columns: 1fr;
    padding: 12px 18px 20px;
  }
}

.gam-card {
  display: flex;
  flex-direction: column;
  padding: 24px;
  border-radius: 18px;
  position: relative;
  transition: all 0.3s ease;
}

.gam-card--free {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.gam-card--free:hover {
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.05);
}

.gam-card--vip {
  background: linear-gradient(145deg, rgba(24, 214, 0, 0.06), rgba(0, 0, 0, 0.4));
  border: 1.5px solid rgba(24, 214, 0, 0.35);
  box-shadow: 0 8px 30px rgba(24, 214, 0, 0.08);
}
.gam-card--vip:hover {
  border-color: #18d600;
  box-shadow: 0 8px 32px rgba(24, 214, 0, 0.18);
}

.gam-card__badge-wrap {
  margin-bottom: 12px;
}

.gam-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.68rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 4px 10px;
  border-radius: 9999px;
}

.gam-badge--free {
  background: rgba(255, 255, 255, 0.08);
  color: #cbd5e1;
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.gam-badge--vip {
  background: linear-gradient(135deg, rgba(24, 214, 0, 0.2), rgba(250, 204, 21, 0.2));
  color: #4ade80;
  border: 1px solid rgba(24, 214, 0, 0.5);
}

.gam-card__title {
  font-size: 1.25rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 8px;
}

.gam-card__desc {
  font-size: 0.84rem;
  color: #94a3b8;
  line-height: 1.45;
  margin-bottom: 16px;
}

.gam-card__features {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
  flex-grow: 1;
}

.gam-feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.8rem;
  color: #cbd5e1;
}

.gam-check-icon {
  width: 16px;
  height: 16px;
  color: #18d600;
  flex-shrink: 0;
}

.gam-card__price {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 18px;
}

.gam-price-tag {
  font-size: 1.6rem;
  font-weight: 900;
  color: #ffffff;
}

.gam-price-sub {
  font-size: 0.78rem;
  color: #64748b;
}

/* ================= VIP SELECTOR & PREVIEW ================= */
.gam-plan-selector {
  margin-bottom: 10px;
}

.gam-plan-label {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  color: #94a3b8;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.gam-select {
  width: 100%;
  background: #020617;
  border: 1px solid rgba(24, 214, 0, 0.3);
  color: #f8fafc;
  padding: 8px 12px;
  border-radius: 10px;
  font-size: 0.82rem;
  font-weight: 600;
  outline: none;
  cursor: pointer;
  transition: all 0.2s;
}
.gam-select:focus {
  border-color: #18d600;
  box-shadow: 0 0 0 2px rgba(24, 214, 0, 0.2);
}

.gam-vip-preview {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 140px;
  overflow: hidden;
  margin-bottom: 14px;
}

.gam-vip-scale {
  transform: scale(0.55);
  transform-origin: center center;
}

/* ================= BOTONES ================= */
.gam-btn {
  width: 100%;
  padding: 12px 18px;
  border-radius: 12px;
  font-size: 0.88rem;
  font-weight: 800;
  cursor: pointer;
  transition: all 0.25s ease;
  margin-top: auto;
  border: none;
  text-align: center;
}

.gam-btn--free {
  background: rgba(255, 255, 255, 0.08);
  color: #f8fafc;
  border: 1px solid rgba(255, 255, 255, 0.16);
}
.gam-btn--free:hover {
  background: rgba(255, 255, 255, 0.16);
  border-color: rgba(255, 255, 255, 0.3);
}

.gam-btn--vip {
  background: linear-gradient(135deg, #18d600 0%, #15803d 100%);
  color: #ffffff;
  box-shadow: 0 4px 18px rgba(24, 214, 0, 0.35);
}
.gam-btn--vip:hover {
  background: linear-gradient(135deg, #22e609 0%, #16a34a 100%);
  box-shadow: 0 6px 24px rgba(24, 214, 0, 0.5);
  transform: translateY(-1px);
}

/* ================= FOOTER ================= */
.gam-footer {
  padding: 14px 32px 18px;
  background: rgba(0, 0, 0, 0.25);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 0.84rem;
}

.gam-footer__text {
  color: #94a3b8;
}

.gam-login-link {
  color: #18d600;
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s;
}
.gam-login-link:hover {
  color: #4ade80;
}
</style>
